export function formatXof(amount: number | null | undefined): string {
  if (amount == null || isNaN(amount)) return "0 F CFA";
  return new Intl.NumberFormat("fr-CI", {
    style: "currency",
    currency: "XOF",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount).replace("XOF", "F CFA");
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat("fr-CI", {
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(new Date(iso));
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat("fr-CI", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(iso));
}

/**
 * Date courte jj/mm/aaaa, tolérante au null/0. Retourne "—" si absente ou
 * invalide (évite l'affichage "01/01/1970" quand `createdAt` est null et que
 * seul `paidAt` est renseigné — paiements espèces/manuels non datés à la
 * création). Usage typique : formatDateShort(p.paidAt ?? p.createdAt).
 */
export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return "·";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime()) || d.getTime() === 0) return "·";
  return d.toLocaleDateString("fr-FR");
}

export function formatPhone(p: string | null | undefined): string {
  if (!p) return "";
  // Ensure starts with +225 and formats
  let clean = p.replace(/\D/g, "");
  if (clean.length === 10) clean = "225" + clean;
  if (clean.startsWith("225") && clean.length === 13) {
    return `+225 ${clean.slice(3, 5)} ${clean.slice(5, 7)} ${clean.slice(7, 9)} ${clean.slice(9, 11)} ${clean.slice(11, 13)}`;
  }
  return p;
}

export function statusLabel(status: string): { label: string; color: string; badge: string } {
  switch (status) {
    case "SUCCESS":
      return { label: "Validé", color: "text-sage", badge: "bg-sage/10 text-sage border-sage/20" };
    case "PENDING":
    case "INITIATED":
    case "PROCESSING":
      return { label: "En cours", color: "text-gold", badge: "bg-gold/10 text-gold border-gold/20" };
    case "FAILED":
      return { label: "Échoué", color: "text-destructive", badge: "bg-destructive/10 text-destructive border-destructive/20" };
    case "CANCELLED":
      return { label: "Annulé", color: "text-muted-foreground", badge: "bg-muted text-muted-foreground border-border" };
    default:
      return { label: status, color: "text-navy", badge: "bg-navy/10 text-navy border-navy/20" };
  }
}

/**
 * Adresse masquée pour une liste affichable en public (« k•••@gmail.com ») :
 * la page Utilisateurs du SEDEC est la première ouverte à la connexion, et
 * elle passait sur le grand écran avec de vraies adresses (14/10/2026).
 * L'adresse complète reste dans la fiche « Modifier », ouverte exprès.
 */
export function masquerEmail(email: string | null | undefined): string {
  if (!email) return "";
  const at = email.indexOf("@");
  if (at <= 0) return "•••";
  return `${email[0]}•••${email.slice(at)}`;
}
